// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__Aa5w+","group":"style_group__K5D9z","messageColumn":"style_messageColumn__IX05b","message":"style_message__rksJY","unreadMessage":"style_unreadMessage__Lduhp"};